// src/components/media360/ui/AudioAttachment.jsx
import React from "react";
import { Icon, Label } from "semantic-ui-react";
import { CopyButton } from "./CopyButton";

export function AudioAttachment({ audio, disabled }) {
  if (!audio) return null;

  return (
    <div
      style={{
        marginTop: 8,
        padding: 10,
        borderRadius: 8,
        background: "#f8f8f8",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}
        >
          <Icon name="music" />
          <strong
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            Audio:
          </strong>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {audio.name}
          </span>
          <Label size="tiny" basic>
            {Math.round((audio.size || 0) / 1024)} KB
          </Label>
        </div>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <CopyButton
            value={audio.publicUrl}
            label="Copiar URL audio"
            icon="copy"
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
}
